export const environment = {
  production: false,
  csrfEnabled: true,
  mockBackend: 'CI_APP_VIA_FRONTEND_MOCKBACKEND',
  APIEndpoint: 'CI_APP_VIA_FRONTEND_APIENDPOINT' ,
  version: 'CI_APP_VIA_FRONTEND_VERSION',
  gaTagId: 'CI_APP_VIA_FRONTEND_GATAGID',
  urlCertidoesIntranet: 'CI_APP_VIA_FRONTEND_URLCERTIDOESINTRANET',
  urlCertidoesInternetPF: 'CI_APP_VIA_FRONTEND_URLCERTIDOESINTERNETPF',
  urlCertidoesInternetPJ: 'CI_APP_VIA_FRONTEND_URLCERTIDOESINTERNETPJ',
  urlExtratoPaex: 'CI_APP_VIA_FRONTEND_URLEXTRATOPAEX',
  urlExtratoPgfn: 'CI_APP_VIA_FRONTEND_URLEXTRATOPGFN',
  urlInscricaoPgfn: 'CI_APP_VIA_FRONTEND_URLINSCRICAOPGFN',
  urlSisparConsultaDarf: 'CI_APP_VIA_FRONTEND_URLSISPARCONSULTADARF',
  urlExtratoIrpf: 'CI_APP_VIA_FRONTEND_URLEXTRATOIRPF',
  urlPortalIrpf: 'CI_APP_VIA_FRONTEND_URLPORTALIRPF',
  urlPortalSiefWeb: 'CI_APP_VIA_FRONTEND_URLPORTALSIEFWEB',
  urlPortalDirf: 'CI_APP_VIA_FRONTEND_URLPORTALDIRF',
  urlE_Defesa: 'CI_APP_VIA_FRONTEND_URLE_DEFESA',
  urlPortalCadastros: 'CI_APP_VIA_FRONTEND_URLPORTALCADASTROS',
  urlTOM: 'CI_APP_VIA_FRONTEND_URLTOM',
  urlExtratoDirpf: 'CI_APP_VIA_FRONTEND_URLEXTRATODIRPF',
  urlPortalIrpfOmissos: 'CI_APP_VIA_FRONTEND_URLPORTALIRPFOMISSOS'
};
